/**
 * Shopify Ajaxify Shop.
 *
 * @uses Modified Shopify jQuery API (link to it)
 *
 */

jQuery(document).ready(function () {
//Begin Wrapper

    var jQ = jQuery;

    /**
     * Collection of Selectors for various pieces on the page we need to update
     *
     * I've tried to keep these as general and flexible as possible, but
     * if you are doing your own markup, you may find you need to change some of these.
     *
     */
    var selectors = {
        // Any elements(s) with this selector will have the total item count put there on add to cart.
        TOTAL_ITEMS: '.count',
        TOTAL_PRICE: '.cart-total-price',

        SUBMIT_ADD_TO_CART: 'input[type=image], input.submit-add-to-cart',

        FORM_ADD_TO_CART: 'form[action*="/cart/add"]',

        FORM_UPDATE_CART: 'form[name=cartform]',
        //The actual Update Button
        FORM_UPDATE_CART_BUTTON: 'form[name=cartform] input[name=update]',
        //All the buttons on the form
        FORM_UPDATE_CART_BUTTONS: 'input[type=image], input.button-update-cart',

        LINE_ITEM_ROW: '.cart-line-item',
        LINE_ITEM_QUANTITY_PREFIX: 'input#updates_',
        LINE_ITEM_PRICE_PREFIX: '.cart-line-item-price-',

        LINE_ITEM_REMOVE: '.remove a',

        EMPTY_CART_MESSAGE: '#empty',

        QUICK_CART_MENU: 'div.cart_menu'
    };


    /**
     * Collection of text strings. This is where you would change for a diff language, for example.
     *
     */
    var text = {
        ITEM: 'Item',
        ITEMS: 'Items'
    };

//Convenience method to format money. 
//Can just transform the amount here if needed
    window.formatMoney = function (price) {
        return Shopify.formatMoney(price, app.data.money_format);
    };

// Set a flag when the checkout button is clicked
    window._checkoutSubmit = false;
    
    // Handle checkout button clicks with multiple event types for better iOS Safari compatibility
    jQ(document).on('click touchstart', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function (e) {
        console.log('Ajaxify: Checkout button clicked/touched');
        window._checkoutSubmit = true;
        // Also set a data attribute on the form for additional detection
        jQ(this).closest('form').attr('data-checkout-submit', 'true');
    });

    jQ('form[action*="/cart"]').submit(function (e) {
        var $form = jQ(e.target);
        var submitButton = $form.find('input[name="checkout"], button[name="checkout"], input[name="goto_pp"], button[name="goto_pp"], input[name="goto_gc"], button[name="goto_gc"]');
        
        // If this is a checkout action, don't intercept - let it redirect
        if (submitButton.length > 0) {
            console.log('Ajaxify: Checkout action detected - not intercepting form submission');
            return true; // allow normal submit/redirect
        }
        
        var $submitter = jQ(document.activeElement);
        if ($submitter.is('[name="checkout"], [name="goto_pp"], [name="goto_gc"]')) {
            return true; // allow normal submit
        }
        
        // Prevent default submission - we'll handle it after validation
        e.preventDefault();
        
        // Check quote tag validation first - products with quote_auto or quote_phone cannot be added to cart
        var hasQuoteAuto = $form.data('has-quote-auto');
        var hasQuotePhone = $form.data('has-quote-phone');
        
        // Convert string "true"/"false" to boolean for comparison
        var isQuoteAuto = hasQuoteAuto === true || hasQuoteAuto === 'true' || String(hasQuoteAuto).toLowerCase() === 'true';
        var isQuotePhone = hasQuotePhone === true || hasQuotePhone === 'true' || String(hasQuotePhone).toLowerCase() === 'true';
        
        if (isQuoteAuto || isQuotePhone) {
            var quoteErrorMessage = 'This product requires a quote. Please use the quote request button or call 1-877-357-9663.';
            alert(quoteErrorMessage);
            
            // Re-enable the Add To Cart button
            jQ(e.target).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', false).removeClass('disabled');
            
            return false;
        }
        
        // Get validation data from form
        var minimumQuantity = parseFloat($form.data('minimum-quantity')) || 1;
        var sqftExist = $form.data('sqft-exist');
        var sqftPerCarton = parseFloat($form.data('sqft-per-carton')) || 0;
        var enableSheets = $form.data('enable-sheets');
        var newProductVendor = $form.data('product-vendor');
        var productId = $form.data('product-id');
        
        // Get quantity from form input (check multiple possible selectors)
        // Exclude coverage inputs - they have name="quantity" but class="coverage" and contain sqft values, not carton counts
        // Coverage inputs have class="coverage", quantity inputs have class="quantity" (may also be "txtbox quantity")
        var quantityInput = $form.find('input.quantity').not('.coverage');
        // Fallback: if no match, try other selectors but exclude coverage class
        if (!quantityInput.length) {
            quantityInput = $form.find('#quantity').not('.coverage');
        }
        if (!quantityInput.length) {
            quantityInput = $form.find('input[name="quantity"]').not('.coverage');
        }
        var quantityToAdd = parseInt(quantityInput.first().val(), 10) || 1;
        
        // Ensure variant ID is present before proceeding
        // Check multiple possible locations for variant ID
        var variantId = null;
        
        // First, try to find variant ID in form inputs/selects
        var variantIdInput = $form.find('select[name="id"], input[name="id"]');
        if (variantIdInput.length > 0) {
            variantId = variantIdInput.val();
        }
        
        // If no variant ID found, try to get it from the product select element
        if (!variantId || variantId === '' || variantId === null) {
            var productSelectId = 'product-select-' + productId;
            var productSelect = $form.find('#' + productSelectId);
            if (productSelect.length > 0) {
                variantId = productSelect.val();
            }
        }
        
        // Also check if Shopify.OptionSelectors created a hidden select
        if (!variantId || variantId === '' || variantId === null) {
            var hiddenSelect = $form.find('select[id*="product-select"][id*="option"]').first();
            if (hiddenSelect.length > 0) {
                // Try to find the main product select that OptionSelectors uses
                var mainSelect = $('#product-select-' + productId);
                if (mainSelect.length > 0) {
                    variantId = mainSelect.val();
                }
            }
        }
        
        // Validate that we have a variant ID before proceeding
        if (!variantId || variantId === '' || variantId === null || variantId === 'undefined') {
            console.error('No valid variant ID found in form. Cannot add to cart.');
            console.log('Form data:', {
                formId: $form.attr('id'),
                productId: productId,
                variantInputs: $form.find('select[name="id"], input[name="id"]').length,
                productSelect: $('#product-select-' + productId).length
            });
            
            // Try to auto-select first available variant if possible
            var productSelect = $('#product-select-' + productId);
            if (productSelect.length > 0) {
                var firstOption = productSelect.find('option:not([disabled]):first');
                if (firstOption.length > 0 && firstOption.val()) {
                    console.log('Auto-selecting first available variant:', firstOption.val());
                    productSelect.val(firstOption.val());
                    variantId = firstOption.val();
                    // Trigger change to update UI
                    productSelect.trigger('change');
                }
            }
            
            // If still no variant ID, show error
            if (!variantId || variantId === '' || variantId === null || variantId === 'undefined') {
                alert('Please select a product option before adding to cart.');
                // Re-enable the Add To Cart button
                jQ(e.target).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', false).removeClass('disabled');
                return false;
            }
        }
        
        // Function to validate and proceed with cart add
        var validateAndAddToCart = function(cart) {
            // Check minimum quantity validation
            if (minimumQuantity > 1) {
                var currentCartQuantity = 0;
                var quantityToValidate = quantityToAdd;
                var minimumToValidate = minimumQuantity;
                
                // Find existing quantity of this product in cart
                if (cart.items && cart.items.length > 0) {
                    for (var i = 0; i < cart.items.length; i++) {
                        if (cart.items[i].product_id == productId) {
                            currentCartQuantity += parseInt(cart.items[i].quantity, 10);
                        }
                    }
                }
                
                // Convert quantities for validation based on product type
                // This matches the logic in enableCart function in product.liquid
                var isSqftProduct = sqftExist === true || sqftExist === 'true' || String(sqftExist).toLowerCase() === 'true';
                var isSheetsProduct = enableSheets === true || enableSheets === 'true' || String(enableSheets).toLowerCase() === 'true';
                
                if (isSqftProduct) {
                    if (isSheetsProduct) {
                        // SQFT Tile products: quantities are already in sheets, no conversion needed
                        // quantityToValidate, currentCartQuantity, and minimumToValidate are all in sheets
                    } else {
                        // Regular SQFT products: convert cartons to sqft for validation
                        // quantityToAdd is in cartons, convert to sqft
                        quantityToValidate = quantityToValidate * sqftPerCarton;
                        // currentCartQuantity is in cartons, convert to sqft
                        currentCartQuantity = currentCartQuantity * sqftPerCarton;
                        // minimumQuantity is in cartons (minimumCtns), convert to sqft
                        minimumToValidate = minimumQuantity * sqftPerCarton;
                    }
                }
                // For eaches products: quantities are already in units, no conversion needed
                
                // Check if total quantity (current + new) meets minimum requirement
                // Use epsilon tolerance for floating point comparisons to handle rounding issues
                // This matches the logic in enableCart function in product.liquid
                var totalQuantity = currentCartQuantity + quantityToValidate;
                var epsilon = 0.01; // 0.01 sqft tolerance for floating point precision
                var meetsMinimum = totalQuantity >= (minimumToValidate - epsilon);
                
                if (!meetsMinimum) {
                    var minMessage = '';
                    if (isSqftProduct) {
                        if (isSheetsProduct) {
                            minMessage = 'Please add a minimum of ' + minimumQuantity + ' sheets to cart.';
                        } else {
                            minMessage = 'Please add a minimum of ' + minimumToValidate + ' sqft to cart.';
                        }
                    } else {
                        minMessage = 'Please add a minimum of ' + minimumQuantity + ' to cart.';
                    }
                    alert(minMessage);
                    
                    // Re-enable the Add To Cart button
                    jQ(e.target).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', false).removeClass('disabled');
                    
                    return false;
                }
            }
            
            // Check vendor validation with exception support
            if (newProductVendor && newProductVendor.trim() !== '') {
                // Get selected variant SKU from the form
                var newProductSku = null;
                var variantSelect = jQ(e.target).find('select[name="id"], #product-select-' + productId);
                if (variantSelect.length > 0) {
                    var selectedOption = variantSelect.find('option:selected');
                    if (selectedOption.length > 0) {
                        var skuValue = selectedOption.data('sku') || selectedOption.attr('data-sku') || null;
                        // Ensure SKU is a string (data() might return a number)
                        newProductSku = skuValue != null ? String(skuValue) : null;
                    }
                }
                
                // Use exception-aware validation (reuse the same function from api.jquery.js)
                // Note: This function should be defined globally or we need to duplicate the logic
                // For now, we'll duplicate the logic here to avoid dependencies
                var VENDOR_EXCEPTIONS_LOCAL = {
                    'QW100LV': {
                        allowedVendors: ['floorlife', 'mohawk', 'shaw', 'coretec', 'anderson']
                    }
                };
                
                var ALLOWED_VENDOR_COMBINATIONS = [
                    ['laticrete', 'tier systems']
                ];
                
                function isVendorCombinationAllowedLocal(cartItems, newProductVendor, newProductSku) {
                    var newVendorLower = String(newProductVendor || '').trim().toLowerCase();
                    var newSku = String(newProductSku || '').trim().toUpperCase();
                    
                    var cartVendors = new Set();
                    var cartSkus = new Set();
                    
                    if (cartItems && cartItems.length > 0) {
                        for (var i = 0; i < cartItems.length; i++) {
                            var itemVendor = String(cartItems[i].vendor || 
                                             cartItems[i].product_vendor || 
                                             (cartItems[i].product && cartItems[i].product.vendor) ||
                                             '').trim().toLowerCase();
                            if (itemVendor) {
                                cartVendors.add(itemVendor);
                            }
                            
                            var itemSku = String(cartItems[i].sku || '').trim().toUpperCase();
                            if (itemSku) {
                                cartSkus.add(itemSku);
                            }
                        }
                    }
                    
                    if (newVendorLower) {
                        cartVendors.add(newVendorLower);
                    }
                    if (newSku) {
                        cartSkus.add(newSku);
                    }
                    
                    var hasExceptionProduct = false;
                    var exceptionAllowedVendors = null;
                    
                    if (newSku && VENDOR_EXCEPTIONS_LOCAL[newSku]) {
                        hasExceptionProduct = true;
                        exceptionAllowedVendors = VENDOR_EXCEPTIONS_LOCAL[newSku].allowedVendors.map(function(v) {
                            return v.toLowerCase();
                        });
                    }
                    
                    cartSkus.forEach(function(sku) {
                        if (VENDOR_EXCEPTIONS_LOCAL[sku]) {
                            hasExceptionProduct = true;
                            var allowed = VENDOR_EXCEPTIONS_LOCAL[sku].allowedVendors.map(function(v) {
                                return v.toLowerCase();
                            });
                            if (!exceptionAllowedVendors) {
                                exceptionAllowedVendors = allowed;
                            } else {
                                exceptionAllowedVendors = exceptionAllowedVendors.filter(function(v) {
                                    return allowed.indexOf(v) !== -1;
                                });
                            }
                        }
                    });
                    
                    if (hasExceptionProduct && exceptionAllowedVendors) {
                        // Find the vendor(s) of exception products
                        var exceptionProductVendors = new Set();
                        cartSkus.forEach(function(sku) {
                            if (VENDOR_EXCEPTIONS_LOCAL[sku]) {
                                for (var j = 0; j < cartItems.length; j++) {
                                    var itemSku = String(cartItems[j].sku || '').trim().toUpperCase();
                                    if (itemSku === sku) {
                                        var itemVendor = String(cartItems[j].vendor || 
                                                         cartItems[j].product_vendor || 
                                                         (cartItems[j].product && cartItems[j].product.vendor) ||
                                                         '').trim().toLowerCase();
                                        if (itemVendor) {
                                            exceptionProductVendors.add(itemVendor);
                                        }
                                    }
                                }
                            }
                        });
                        
                        if (newSku && VENDOR_EXCEPTIONS_LOCAL[newSku] && newVendorLower) {
                            exceptionProductVendors.add(newVendorLower);
                        }
                        
                        var allVendorsAllowed = true;
                        cartVendors.forEach(function(vendor) {
                            var isExceptionVendor = exceptionProductVendors.has(vendor);
                            var isAllowedVendor = exceptionAllowedVendors.indexOf(vendor) !== -1;
                            if (!isExceptionVendor && !isAllowedVendor) {
                                allVendorsAllowed = false;
                            }
                        });
                        return allVendorsAllowed;
                    }
                    
                    // If cart vendors are a subset of an allowed combination, allow
                    for (var k = 0; k < ALLOWED_VENDOR_COMBINATIONS.length; k++) {
                        var allowedSet = ALLOWED_VENDOR_COMBINATIONS[k];
                        var allInSet = true;
                        cartVendors.forEach(function(v) {
                            if (allowedSet.indexOf(v) === -1) {
                                allInSet = false;
                            }
                        });
                        if (allInSet && cartVendors.size > 0) {
                            return true;
                        }
                    }
                    
                    return cartVendors.size <= 1;
                }
                
                if (!isVendorCombinationAllowedLocal(cart.items || [], newProductVendor, newProductSku)) {
                    var errorMessage = 'Your cart includes multiple vendors. Free shipping over $1,500 applies only to single-vendor orders. Remove other vendors or call 877-357-9663 for multi-vendor assistance.';
                    alert(errorMessage);
                    
                    // Re-enable the Add To Cart button
                    jQ(e.target).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', false).removeClass('disabled');
                    
                    return false;
                }
            }
            
            // All validations passed, proceed with normal flow
            //Disable the Add To Cart button, add a disabled class.
            jQ(e.target).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', true).addClass('disabled');

            //Can't use updateCartFromForm since you need the item added before you can update (otherwise, would have been more convenient)
            //So, in onItemAdded, we Shopify.getCart() to force the repaint of items in cart.
            Shopify.addItemFromForm(e.target);
        };
        
        // Get current cart to validate minimum quantity and vendor
        jQuery.getJSON('/cart.js', validateAndAddToCart);
    });


//We only want to interrupt the UPDATE, not the CHECKOUT process
    jQ(selectors.FORM_UPDATE_CART_BUTTON).click(function (e) {
        e.preventDefault();
        jQ(e.target.form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', true).addClass('disabled');
        Shopify.updateCartFromForm(e.target.form);
    });

//Delegate the Remove Link functionality on the cart page.
    jQ(selectors.FORM_UPDATE_CART).delegate(selectors.LINE_ITEM_REMOVE, 'click', function (e) {
        e.preventDefault();
        //Get the variant ID from the URL
        var vid = this.href.split('/').pop().split('?').shift();
        Shopify.removeItem(vid);
        jQ(this).parents(selectors.LINE_ITEM_ROW).remove();
    });

    /**
     * Shopify.showModal
     *
     * @param string contents
     * @param integer hideDelay
     */
    Shopify.modalTimer = false;
    Shopify.showModal = function (contents, hideDelay) {

        if (Shopify.modalTimer) {
            window.clearTimeout(Shopify.modalTimer);
        }

        //Ensure the plugin is loaded
        if (typeof $().magnificPopup !== 'function') {
            return
        }

        //Check the function vars have been sent
        if (typeof contents === 'undefined') {
            return
        }
        if (typeof hideDelay === 'undefined') {
            var hideDelay = 7000 /* default */
        }

        //Open the modal
        $.magnificPopup.open({
            items: {
                src: '<div class="mfp-with-anim modal-popup">' + contents + '</div>',
                type: 'inline'
            },
            mainClass: 'mfp-move-from-top',
            removalDelay: 1000
        });

        //Autoclose the modal
        var magnificPopup = $.magnificPopup.instance;
        Shopify.modalTimer = window.setTimeout(function () {
            if (typeof magnificPopup !== 'undefined') {
                magnificPopup.close();
            }
        }, hideDelay);

    };

    
    Shopify.addImageSize = function (src, size) {
        if (typeof size === 'undefined') {
            return src;
        }
        if (src === null) {
            return "\/\/flooringmarket.com\/cdn\/shop\/t\/85\/assets\/no-image.gif?v=13552455658106495141771948196" }
        size = '_' + size + '.';
        return src.replace(/.([^.]*)$/, size + '$1');
    };

    
    Shopify.updateQuickCart = function (cart, form) {
        var t = jQ(selectors.QUICK_CART_MENU);
        if (t.length) {
            if (cart.items.length) {

                var toAppend = [];
                for (var i = 0; i < cart.items.length; i++) {
                    var itemPrice = cart.items[i].price;
                    //var itemPriceConverted = Shopify.formatMoney(itemPrice);

                    var quantity = '';
                    var infoMessage = '';

                    var productIdForm = $(form.productId).val();
                    var cartProId = cart.items[i].product_id;

                    if (typeof form !== 'undefined' && $(form.productId).val() == cart.items[i].product_id) {
                        var product = cart.items[i];
                        var sqftExist = $(form.sqftExist).val();

                        if (sqftExist == 'true') {
                            var sqftPerCarton = parseFloat($(form.sqftPerCarton).val());
                            var price = Math.round(product.price / sqftPerCarton);
                            var itemPriceConverted = Shopify.formatMoney(price, app.data.money_format);

                            infoMessage = itemPriceConverted + ' per Sq.Ft.';
                        } else {
                            var itemPriceConverted = Shopify.formatMoney(product.price, app.data.money_format);
                            infoMessage = itemPriceConverted;

                            
                        }

                        quantity = 'x' + product.quantity;
                    } else {
                        var itemPriceConverted = Shopify.formatMoney(itemPrice, app.data.money_format);

                        

                        quantity = 'x' + cart.items[i].quantity;

                        infoMessage = itemPriceConverted;
                    }

                    console.log(cart.items);

                    var row = '<div class="cart_row"><ul><li><div class="pro_img"><a href="' + cart.items[i].url +
                        '"><img src="' + Shopify.addImageSize(cart.items[i].image, 'small') + '" alt="' + cart.items[i].title +
                        '"></a></div></li><li><h5><a href="' + cart.items[i].url +
                        '" class="item-name">' + cart.items[i].title +
                        '</a></h5><p class="product-type">' + cart.items[i].product_type + '</p></li><li><h5 style="text-transform: none !important;">' + quantity + '</h5></li><li><div class="price pull-right test"><span class="money">' + infoMessage +
                        '</span></div></li></ul></div>';
                    toAppend.push(row);
                }
                ;
                var checkoutRow = t.find('div.checkout_row');
                if (checkoutRow.length) { /* we have existing items in the quick cart */
                    t.find('div.cart_row').html(toAppend.join(''));
                } else {
                    //
                    checkoutRow = '<div class="checkout_row clearfix"><a href="/cart" class="checkout_btn">View Cart</a></div>';
                    var form = jQ('<form />', {
                        'action': '/cart',
                        'method': 'post',
                        'novalidate': 'novalidate'
                    });
                    form.append(toAppend.join(''), checkoutRow)
                    t.find('div.cart_row').html('').append(form);
                }


            }
        }

        if (typeof cartUpdated === 'function') {
            cartUpdated(cart);
        }

        Shopify.onCartUpdate(cart);
    };


    /**
     * Shopify.onItemAdded
     *
     * Triggered by the response when something is added to the cart via the add to cart button.
     * This is where you would want to put any flash messaging, for example.
     *
     * @param object line_item
     * @param HTMLelement/String Form HTMLElement, or selector
     */
    Shopify.onItemAdded = function (line_item, form) {

        //Default behaviour for this modification:
        //When a Add To Cart form is clicked, we disable the button and apply a class of disabled.
        //Here is where we remove the disabled class, and reactivate the button.
        jQ(form).find(selectors.SUBMIT_ADD_TO_CART).attr('disabled', false).removeClass('disabled');

        var product = line_item;


        var sqftExist = $(form.sqftExist).val();

        var infoMessage = '';

        if (sqftExist == 'true') {
            var sqftPerCarton = parseFloat($(form.sqftPerCarton).val());
            var price = Math.round(line_item.price / sqftPerCarton);
            var itemPriceConverted = Shopify.formatMoney(price, app.data.money_format);

            infoMessage = itemPriceConverted + ' per Sq.Ft.';
        } else {
            var itemPriceConverted = Shopify.formatMoney(line_item.price, app.data.money_format);
            infoMessage = itemPriceConverted;
        }

        var productTitle = jQ('<div />', {'class': 'modal-cart-title'}).html(line_item.title);
        var discountMessage = '<div style="color: red; font-size: 14px; text-align: right; font-weight: 600;">*Discounts Not Applied Until Cart Page</div>';
        //You can add any extra messaging you would want here.
        var message = jQ('<div />', {
            'class': 'modal-cart-success'
        }).html('<i class="fa fa-check"></i><span class="line-item-count hidden"></span> added to your shopping cart.');
        if (typeof line_item.quantity !== 'undefined') {
            message.find('.line-item-count').text(line_item.quantity).removeClass('hidden');
        }

        var message2 = jQ('<div />', {'class': 'modal-cart-info'}).html(infoMessage);

        //The buttons
        var btnCart = jQ('<a />', {
            'class': 'modal-button',
            'href': '/cart'
        }).text("View Cart");
        /* var btnCheckout = jQ('<a />',{
             'class':'modal-button2',
             'href':'/checkout'
         }).text("Check Out");*/

        var contentsWrapper = jQ('<div />', {'class': 'product-contents-wrapper clearfix'});
        //Assume no image
        var image = '';
        if (typeof line_item.image !== 'undefined') {
            //If we have an image, add it
            var imageSize = 'large'; /* Bigger than what you need, but it should already be loaded */
            image = jQ('<div />', {'class': 'modal-product-image'}).html('<img src="' +
                Shopify.addImageSize(line_item.image, imageSize) + '" />');
        }
        var contents = jQ('<div />').append(productTitle, message2, discountMessage, message, btnCart);
        contentsWrapper.append(image, contents);
        var s = contentsWrapper.wrap('<p>').parent().html();
        Shopify.showModal(s);

        //Get the state of the cart, which will trigger onCartUpdate
        Shopify.getCart(function (cart) {
            Shopify.updateQuickCart(cart, form);
        });

    };


    /**
     * This updates the N item/items left in your cart
     *
     * It's setup to match the HTML used to display the Cart Count on Load. If you change that (in your theme.liquid)
     * you will probably want to change the message html here.
     * This will update the HTML in ANY element with the class defined in selectors.TOTAL_ITEMS
     *
     * @param object the cart object.
     * @param HTMLElement form. If included, we know its an Update of the CART FORM, which will trigger additional behaviour.
     */
    Shopify.onCartUpdate = function (cart, form) {

        // Total Items Update
        var message = cart.item_count;
        if (cart.item_count > 0) {
            jQ(selectors.TOTAL_ITEMS).text(message).removeClass('hidden');
            // Also update cart-count elements
            jQ('.cart-count').text(message).removeClass('hidden');
        } else {
            jQ(selectors.TOTAL_ITEMS).text('').addClass('hidden');
            // Also update cart-count elements
            jQ('.cart-count').text('').addClass('hidden');
        }


        // Price update - any element matching the selector will have their contents updated with the cart price.
        var price = window.formatMoney(cart.total_price);
        jQ(selectors.TOTAL_PRICE).html(price);

        //If the EMPTY_CART_MESSAGE element exiss, we should show it, and hide the form.
        if ((jQ(selectors.EMPTY_CART_MESSAGE).length > 0) && cart.item_count == 0) {
            jQ(selectors.FORM_UPDATE_CART).hide();
            jQ(selectors.EMPTY_CART_MESSAGE).show();
        }

        // A form was passed in?
        form = form || false;
        //so it's the cart page form update, trigger behaviours for that page
        if (form) {
            //Nothing left in cart, we reveal the Nothing in cart content, hide the form.
            if (cart.item_count > 0) {
                //Loops through cart items, update the prices.
                jQ.each(cart.items, function (index, cartItem) {
                    jQ(selectors.LINE_ITEM_PRICE_PREFIX + cartItem.id).html(window.formatMoney(cartItem.line_price));
                    jQ(selectors.LINE_ITEM_QUANTITY_PREFIX + cartItem.id).val(cartItem.quantity);
                });

                //And remove any line items with 0
                jQ(form).find('input[value=0]').parents(selectors.LINE_ITEM_ROW).remove();

                //Since we are on the cart page, reenable the buttons we disabled
                jQ(form).find(selectors.FORM_UPDATE_CART_BUTTONS).attr('disabled', false).removeClass('disabled');

            }
            //You can add any extra messaging you would want here.
            console.log('cart updated');
            //successMessage('Cart Updated.');
        }
    };


    Shopify.onError = function (XMLHttpRequest, textStatus) {
        var response = jQuery.parseJSON(XMLHttpRequest.responseText);
        var error = response.description;

        if (typeof $().magnificPopup !== 'function') {
            alert(error);
        } else {
            $.magnificPopup.open({
                items: {
                    src: '<div class="mfp-with-anim modal-popup error"><h3>Error</h3>' + error + '</div>',
                    type: 'inline'
                },
                mainClass: 'mfp-move-from-top',
                removalDelay: 1000
            });
        }
    };

//End Wrapper    
});